import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import FoodDialog from "dialogs/FoodDialog";
import { Colors } from "helpers/Consts";
import { useState } from "react";
import { IProduct } from "types/Product";
import { UseQueryResult } from "react-query";
import { IShoppingBagData } from "../../types/ShoppingBag";
import { IPlaceData } from "../../types/Place";

type Props = {
  product: IProduct;
  shoppingBagQuery: UseQueryResult<IShoppingBagData>
  placeInfo: IPlaceData | undefined
};

function TrendCard({ product, shoppingBagQuery,placeInfo }: Props) {
  const [open, setOpen] = useState<boolean>(false);

  const handleDialog = () => {
    return setOpen(!open);
  };
  return (
    <>
      <FoodDialog open={open} handleClose={handleDialog} product={product} shoppingBagQuery={shoppingBagQuery} placeInfo={placeInfo} />
      <Card sx={{ maxWidth: 400, margin: "5px" }} onClick={handleDialog}>
        <CardActionArea>
          {product.image ? (
            <CardMedia
              component="img"
              height="150px"
              sx={{ objectFit: "fill" }}
              image={product?.image != null ? product?.image : ""}
              alt={product?.name}
            />
          ) : (
            <CardMedia
              component="img"
              height="150px"
              sx={{ objectFit: "fill" }}
              image={require("assets/img/noImageProduct.png")}
              alt={product?.name}
            />
          )}

          <CardContent>
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              style={{ fontWeight: 200 }}
              sx={{
                fontSize: {
                  xs: "15px",
                  sm: "20px",
                  md: "22px",
                },
              }}
            >
              {product?.name}
            </Typography>

            <Typography
              variant="body2"
              color={Colors.grayTextColorDarkestDark}
              style={{ fontWeight: 300, fontSize: "11px" }}
            >
              {product?.description}
            </Typography>
            {product?.show_people_served_information
              ? (<Typography
              variant="body2"
              color="black"
              style={{ fontWeight: 700, fontSize: "13px" }}
            >
              Serve até {product.people_served} pessoa(s)
            </Typography>):null}
            <Box
              sx={{
                display: "flex",
              }}
            >
              <Typography
                variant="body2"
                color="green"
                style={{ fontWeight: 700, fontSize: "20px" }}
              >
                {product?.new_price.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </Typography>
              {product.old_price > product.new_price && (
                <Typography
                  variant="body2"
                  color={Colors.grayTextColorDark}
                  style={{
                    fontWeight: 700,
                    fontSize: "20px",
                    marginLeft: "5px",
                    textDecoration: "line-through",
                  }}
                >
                  {product?.old_price.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </Typography>
              )}
            </Box>
          </CardContent>
        </CardActionArea>
      </Card>
    </>
  );
}

export default TrendCard;
